import { SearchResultModel } from "./searchResultModel"

export class UnknownSearchResultModel extends SearchResultModel {}
